import { css } from 'styled-system/css';

export const BetslipFloatImg = ({ active = false }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="133" height="76" fill="none" viewBox="0 0 133 76">
			<path className={active ? style.shadowActive : style.shadow} fillRule="evenodd" d="M119.168 41.31a5.5 5.5 0 1 0-7.479-7.479A14.945 14.945 0 0 0 105.5 32.5c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-2.207-.477-4.302-1.332-6.19Z" clipRule="evenodd" />
			<rect width="30" height="30" x="88" y="30" fill="var(--background-neutral-500-400-bg2, var(--s400))" rx="15" />
			<rect className={active ? style.strokeActive : style.stroke} width="29" height="29" x="88.5" y="30.5" stroke={active ? 'var(--text-primary-500, var(--p500))' : 'var(--lv1-30)'} rx="14.5" />
			<path className={active ? style.iconActive : style.icon} d="M106.105 41.474h2.276a.117.117 0 0 0 .112-.138.129.129 0 0 0-.031-.06l-2.739-2.738a.117.117 0 0 0-.177.018.129.129 0 0 0-.02.064v2.275a.578.578 0 0 0 .579.579Z" />
			<path className={active ? style.iconActive : style.icon} d="M108.826 42.632h-2.721a1.738 1.738 0 0 1-1.737-1.737v-2.721a.175.175 0 0 0-.05-.123.175.175 0 0 0-.123-.051h-4.458A1.737 1.737 0 0 0 98 39.737v10.42a1.737 1.737 0 0 0 1.737 1.738h7.526A1.734 1.734 0 0 0 109 50.158v-7.353a.169.169 0 0 0-.051-.123.17.17 0 0 0-.123-.05Zm-2.721 6.947h-5.21a.58.58 0 0 1-.41-.988.58.58 0 0 1 .41-.17h5.21a.58.58 0 0 1 .41.988.58.58 0 0 1-.41.17Zm0-2.316h-5.21a.58.58 0 0 1-.41-.988.58.58 0 0 1 .41-.17h5.21a.58.58 0 0 1 .41.989.58.58 0 0 1-.41.17Zm0-2.316h-5.21a.58.58 0 0 1-.41-.988.58.58 0 0 1 .41-.17h5.21a.58.58 0 0 1 .41.989.58.58 0 0 1-.41.17Z" />
			<path className={style.badge} d="M109.428 33.357a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" />
			<path fill="var(--text-utility-constant-white-100, var(--white-100))" d="M114.153 36.93c-.33 0-.636-.04-.918-.118a4.84 4.84 0 0 1-.756-.297v-.909c.222.12.462.231.72.333.264.096.555.144.873.144.456 0 .807-.08 1.053-.243a.82.82 0 0 0 .369-.72c0-.318-.12-.564-.36-.738-.234-.18-.6-.27-1.098-.27h-.747v-.819h.774c.378 0 .66-.072.846-.216a.735.735 0 0 0 .288-.612.698.698 0 0 0-.153-.468.835.835 0 0 0-.423-.279 2.147 2.147 0 0 0-.657-.09c-.246 0-.477.03-.693.09a3.375 3.375 0 0 0-.657.243v-.846c.198-.096.42-.177.666-.243a3.01 3.01 0 0 1 .783-.099c.33 0 .621.042.873.126.258.078.474.192.648.342.18.144.312.315.396.513.09.198.135.414.135.648 0 .198-.036.372-.108.522-.066.15-.15.276-.252.378a1.48 1.48 0 0 1-.279.225.664.664 0 0 1-.18.081.946.946 0 0 1 .252.126c.12.066.246.162.378.288.132.126.243.285.333.477.096.186.144.405.144.657 0 .258-.051.495-.153.711-.096.216-.24.405-.432.567a2.152 2.152 0 0 1-.711.37 3.281 3.281 0 0 1-.954.125Z" />
		</svg>
	)
};

const style = {
	badge: css({
		fill: 'var(--background-utility-inverse-54, var(--s300))', 
		_light: {
			fill: 'var(--background-utility-inverse-54, var(--other-lv1-80))',
		},
		_groupActive: {
			fill: 'var(--background-primary-500, var(--p500-50))',
			_mars: {
				fill: 'var(--special-02)',
			},
		},
		_mars: {
			fill: 'gray.600'
		},
	}),
	icon: css({
		fill: 'var(--lv1-100)',
		_mars: {
			fill: 'black.3',
		}
	}),
	iconActive: css({
		fill: 'var(--text-primary-500, var(--p500))', 
		_mars: {
			fill: 'secondary.500',
		}
	}),
	stroke: css({
		stroke: 'var(--lv1-30)',
		_mars: {
			stroke: 'black.3',
		}
	}),
	strokeActive: css({
		stroke: 'var(--text-primary-500, var(--p500))',
		_mars: {
			stroke: 'secondary.500',
		}
	}),
	shadow: css({
		fill: 'var(--background-utility-constant-black-12, var(--lv2-8))',
	}),
	shadowActive: css({
		fill: 'var(--background-primary-500-54, var(--p500-50))',
	}),
}